import './projects.scss'

function Projects() {
  // const { t } = useTranslation()
  
  return (
    <div className='page-projects'>
      sdd
    </div>
  )
}

export default Projects
